import React from 'react';

import { Dropdown } from '@components';

import {
  ANALYTICS_VIEW_OPTIONS,
  LeadAnalyticsCriteria
} from '../../constants/leadAnalytics';

interface AnalyticsViewSelectorProps {
  dropdownId: string;
  view: LeadAnalyticsCriteria;
  onViewChange: (view: LeadAnalyticsCriteria) => void;
}

const AnalyticsViewSelector: React.FC<AnalyticsViewSelectorProps> = ({
  dropdownId,
  view,
  onViewChange
}) => (
  <Dropdown
    dropdownId={dropdownId}
    listId={dropdownId}
    variant="v2"
    usePortal
    stopEventPropagation
    currentFilter={view}
    filterOptions={ANALYTICS_VIEW_OPTIONS}
    onSelectFilter={(value) => onViewChange(value as LeadAnalyticsCriteria)}
    className="!h-9 !w-40 !min-w-40 shrink-0 !items-center !rounded-lg"
    labelStyle="whitespace-nowrap"
    optionsStyle="!max-h-80 !w-40 !min-w-40"
  />
);

export default AnalyticsViewSelector;
